import { render, staticRenderFns } from "./InsuranceCardEducationFooter.vue?vue&type=template&id=27efadbe"
import script from "./InsuranceCardEducationFooter.vue?vue&type=script&lang=js"
export * from "./InsuranceCardEducationFooter.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCardEducationFooter.vue?vue&type=style&index=0&id=27efadbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports